var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRefisterArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.97913 0.646447C7.17439 0.451184 7.49097 0.451184 7.68623 0.646447L11.6862 4.64645C11.8815 4.84171 11.8815 5.15829 11.6862 5.35355L7.68623 9.35355C7.49097 9.54882 7.17439 9.54882 6.97913 9.35355C6.78387 9.15829 6.78387 8.84171 6.97913 8.64645L10.1256 5.5H0.666016C0.389873 5.5 0.166016 5.27614 0.166016 5C0.166016 4.72386 0.389873 4.5 0.666016 4.5H10.1256L6.97913 1.35355C6.78387 1.15829 6.78387 0.841709 6.97913 0.646447Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRefisterArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/RefisterArrow.3f448b94.svg";
export { ForwardRef as ReactComponent };